import { registerFunctionalComponent } from 'js/lib/components/component'
import { autosize } from 'js/lib/autosize'

registerFunctionalComponent('.js-c-form-input--textarea', 'InputTextArea', InputTextArea)

function InputTextArea(component) {
  const textarea = component.element
  const parent = textarea.parentElement
  const counter = parent?.querySelector('.js-character-count')
  const progressCircle = parent?.querySelector('.js-character-progress-circle')

  component.useHandler(() => {
    if (textarea) {
      autosize(textarea)
    }
  })

  if (textarea && counter) {
    const maxLength = parseInt(textarea.getAttribute('maxlength')) || 1000
    const circumference = 2 * Math.PI * 8 // radius is 8

    const updateCount = () => {
      const currentLength = textarea.value.length
      counter.textContent = currentLength

      if (progressCircle) {
        const progress = Math.min(currentLength / maxLength, 1)
        const offset = circumference * (1 - progress)
        progressCircle.style.strokeDashoffset = offset

        // Change color when approaching/exceeding limit
        if (progress >= 1) {
          progressCircle.style.stroke = '#dc2626' // red
        } else if (progress >= 0.9) {
          progressCircle.style.stroke = '#f59e0b' // amber
        } else {
          progressCircle.style.stroke = '#16a34a' // green
        }
      }
    }

    textarea.addEventListener('input', updateCount)
    updateCount()
  }
}
